
import { Options, Vue } from 'vue-class-component';
import Competitor from '@/models/Competitor';

@Options({
  props: {
    position: Number,
    person: Competitor,
    slug: String,
    year: String,
    categoryId: Number,
  },
  emits: ['update'],
})
export default class Placing extends Vue {
  position!: 1|2|3

  get positionText(): string {
    switch (this.position) {
      case 1: return '1st';
      case 2: return '2nd';
      case 3: return '3rd';
      default: return '';
    }
  }
}
